import app from 'lib/store/app'
import user from 'lib/store/user'
import scores from 'lib/store/scores'
import crushes from 'lib/store/crushes'

export default {
  app,
  user,
  scores,
  crushes
}



// WEBPACK FOOTER //
// ./src/lib/redux/reducers.js